export default __webpack_public_path__ + "static/media/cosmicdisco.89691d5e.png";